// extracted by mini-css-extract-plugin
export var brand = "_1e-9";
export var compact = "_1e-6";
export var extraSmall = "_1e-7";
export var icon = "_1e-0";
export var large = "_1e-4";
export var light = "_1e-1";
export var medium = "_1e-5";
export var outline = "_1e-b";
export var primaryDark = "_1e-a";
export var primaryLight = "_1e-8";
export var primaryModern = "_1e-c";
export var success = "_1e-2";
export var successSolid = "_1e-3";